import { StoreNames } from "csi/store/Names";
import { createContext, useContext } from "react";
import { createNamesStore } from "src/c8-platform/service/formService";
import { C8AttributeId, C8NodeType } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";

export interface EnumProps {
	attributeId: C8AttributeId;
	nodeType: C8NodeType;
	nodeUrl: cnl;
	reportOperations: string;
}

export class EnumStore {
	/** attribute id for the form */
	readonly attributeId: C8AttributeId;

	/** node type for the form */
	readonly nodeType: C8NodeType;

	/** node url for the form */
	readonly nodeUrl: cnl;

	/** report operations for the form */
	readonly reportOperations: string;

	/** store names which includes the aggregate store */
	store: StoreNames;

	/** create names store from the form and field data */
	createStore = (): void => {
		this.store = createNamesStore(this.attributeId, this.nodeType, this.nodeUrl, this.reportOperations);
	};

	constructor(
		attributeId: C8AttributeId,
		nodeType: C8NodeType,
		nodeUrl: cnl,
		reportOperations: string,
	) {
		this.attributeId = attributeId;
		this.nodeType = nodeType;
		this.nodeUrl = nodeUrl;
		this.reportOperations = reportOperations;
		this.createStore();
	}
}

export const EnumStoreContext = createContext<EnumStore>(undefined);
export const useEnumStore = (): EnumStore => useContext(EnumStoreContext);
